import React, { useEffect, useState } from "react";
import { Grid, Hidden, Input, InputAdornment, OutlinedInput, TextField, Typography } from "@mui/material";
import { navigate } from "gatsby";
import { IconButton } from "../../Material";
import { Img } from "../../Image";
import { useStyles } from "./Hero.styles";

interface HeroBlogProps {
	tagName?: 'inmobiliario' | 'crédito'
	postTitle?: string
}

export function HeroBlog({ tagName, postTitle }: HeroBlogProps) {
	const { classes, cx } = useStyles()
	const [postName, setPostName] = useState(postTitle || '')

	return (
		<section id="hero" className={classes.root}>
			{/* @ts-ignore */}
			<Hidden mdDown>
				<Img
					src='/assets/images/blog/blog_hero_pattern_l.svg'
					className={cx(classes.pattern, 'l')}
					loadingType='eager'
				/>
				<Img
					src='/assets/images/blog/blog_hero_pattern_r.svg'
					className={cx(classes.pattern, 'r')}
					loadingType='eager'
				/>
			</Hidden>
			<Grid container className={classes.container}>
				<Grid item xs={12}>
					<Typography
						color="primary"
						className={classes.title}
						component='h1'
					>
						Centro de <strong>Aprendizaje Kredi</strong>
					</Typography>
				</Grid>
				<Grid
					item
					xs={12}
					className={classes.inputContainer}
				>
					<OutlinedInput
						id="post_name"
						name="post_name"
						value={postName}
						onChange={(event) => setPostName(event.currentTarget.value)}
						type='text'
						placeholder='Buscar...'
						className={classes.postNameInput}
						endAdornment={(
							<InputAdornment position="start">
								<IconButton
									variant="standard"
									onClick={() => {
										const cleanTag = tagName === 'crédito' ? 'credito' : tagName || ''
										navigate(`/blog/search?postName=${postName}&tagName=${cleanTag}`)
									}}
								>
									<Img src='/assets/images/blog/blog_hero_icon_search.svg' loadingType='eager' />
								</IconButton>
							</InputAdornment>
						)}
					/>
				</Grid>
			</Grid>
		</section>
	)
}